import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSortModule } from "@angular/material/sort";
import { EneIconModule } from "src/app/shared/ui/icon/legacy/icon.module";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonToggleModule } from "src/app/common/components/button-toggle/button-toggle.module";
import { SquareModule } from "src/app/common/components/dialogs/notification-settings/components/square/square.module";
import { TableModule } from "src/app/common/components/table/table.module";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { TabsComponent } from "src/app/shared/ui/tabs/tabs.component";
import { TableFilterModule } from "src/app/slots/three-year-plan/common/components/table/components/table-filter/table-filter.module";
import { TableModule as NgmyTableModule } from "src/app/slots/three-year-plan/common/components/table/table.module";
import { ConfigurationAreaDownloadsComponent } from "./downloads/configuration-area-downloads.component";
import { ModuleInfoColumnComponent } from "./modules-tab/components/module-info-cell/module-info-column.component";
import { MunicipalityInfoColumnComponent } from "./modules-tab/components/municipality-info-cell/municipality-info-column.component";
import { CAModulesTabComponent } from "./modules-tab/container/modules-tab.component";
import { RegionCellComponent } from "./notification-settings/cells/region-cell.component";
import { NestedTableComponent } from "./notification-settings/nested-table/nested-table.component";
import { CANotificationSettingsComponent } from "./notification-settings/notification-settings.component";
import { SeparatedByTypeComponent } from "./notification-settings/separated-by-type/separated-by-type.component";
import { TableExpandableRowsComponent } from "./notification-settings/table/table-expandable-rows.component";

const components = [
  CAModulesTabComponent,
  CANotificationSettingsComponent,
  ConfigurationAreaDownloadsComponent,
  NestedTableComponent,
  SeparatedByTypeComponent,
  TableExpandableRowsComponent
];

@NgModule({
  declarations: [ModuleInfoColumnComponent, MunicipalityInfoColumnComponent, RegionCellComponent, ...components],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    EneButtonModule,
    EneIconModule,
    NgmyTableModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatExpansionModule,
    TableModule,
    MatTooltipModule,
    SquareModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TableFilterModule,
    ButtonToggleModule,
    TabsComponent
  ],
  exports: [...components]
})
export class ConfigurationAreaContentModule {}
